import styled from "styled-components";

export const CompanyMissionV2ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .content_section {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    min-height: calc(100vh - 235px);
    border-radius: 8px;
    display: flex;
    padding: 24px 32px;
    flex-direction: column;
  }

  .header_section {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .back_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 8px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    flex-shrink: 0;

    &:hover {
      background: ${({ theme }) => theme.COLORS.GRAY_8};
    }
  }

  .header_title {
    text-align: center;
    flex: 1;
  }

  .header_title .title_th {
    font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S24};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }

  .header_title .title_en {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    margin-top: 2px;
  }

  .create_btn {
    flex-shrink: 0;
  }

  .tab_count_row {
    margin-top: 20px;
    position: relative;
  }

  .mission_count_label {
    position: absolute;
    right: 0;
    bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
  }

  .mission_count_value {
    font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  }

  .filter_section {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    margin: 20px 0;
  }
  .search_item{
  flex: 1;
    max-width: 280px;
  }
  .dropdown_item {
  flex: 1;
    max-width: 200px;
  }

  .filter_label {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.GRAY_4};
  }

  .search_input_inner {
    position: relative;
    height: 40px;

    .search_icon {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
      display: flex;
      pointer-events: none;
    }

    .search_input {
      width: 100%;
      height: 100%;
      padding: 0 12px 0 36px;
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_25};
      border-radius: 8px;
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      color: ${({ theme }) => theme.COLORS.BLACK_3};
      outline: none;
      box-sizing: border-box;

      &::placeholder {
        color: ${({ theme }) => theme.COLORS.GRAY_4};
      }

      &:focus {
        border-color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
  }

  .filter_buttons {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    flex-shrink: 0;
    margin-left: auto;
  }

  .table_section {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;

    .mission_list_loading {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 280px;
      flex: 1;
    }

    .body_row {
      cursor: pointer;
    }

    > div {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .table_container {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .table_body {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .label_empty {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .pagination_section {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    border-radius: 8px;
  }

  .history_placeholder {
    padding: 48px 16px;
    text-align: center;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    color: ${({ theme }) => theme.COLORS.GRAY_4};
  }
`;
